import { render, staticRenderFns } from "./choiseListTableKehu.vue?vue&type=template&id=5a08aeb9&scoped=true"
import script from "./choiseListTableKehu.vue?vue&type=script&lang=js"
export * from "./choiseListTableKehu.vue?vue&type=script&lang=js"
import style0 from "./choiseListTableKehu.vue?vue&type=style&index=0&id=5a08aeb9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a08aeb9",
  null
  
)

export default component.exports